<template>
    <div>
        <div class="container" v-if="!disable && visible" :style="{ backgroundImage: 'url(static/bg.jpg)' }">
            <img class="logo1" src="static/logoAC.png" />
            <div class="title">福音TV</div>
            <img class="logo2" src="static/logo-icon.png" />
            <div class="blank"></div>
            <a href="http://www.fytvapp.com/mobile/">点此下载 福音TV App观看</a>
            <a href="javascript:;" @click="visible = false">继续网页观看</a>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            visible: true
        }
    },
    props: {
        disable: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style scoped lang='scss'>
.container {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 987;
    width: 100%;
    height: 100vh;
    padding: rem(80) rem(60) rem(200);
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .logo1 {
        height: rem(90);
        margin-bottom: rem(30);
    }

    .title {
        font-size: rem(48);
        margin-bottom: rem(52);
    }

    .logo2 {
        height: rem(200);
    }

    .blank {
        flex: 1;
    }

    >a {
        width: 100%;
        margin-bottom: 30px;
        line-height: 50px;
        border-radius: 50px;
        background-color: #0eb294;
        color: white;
        text-align: center;
        font-size: 20px;

        &:last-child {
            background-color: lighten(#0eb294, 10%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?a8cfb5b0